import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const useSelectedModule = () => {
  const location = useLocation();

  const { moduleList } = useSelector(({ role }) => role);

  const selectedModule = useMemo(() => {
    return (
      moduleList?.find((item) => item?.module_name === location?.pathname) || {}
    );
  }, [moduleList, location?.pathname]);

  return { selectedModule };
};

export default useSelectedModule;
